import React from 'react';
import { motion } from 'framer-motion';
import { mediaItems as fallbackMediaItems } from '../data/mediaData';

const MediaContent = ({ mediaItems, onImageClick }) => {
  const items = mediaItems && mediaItems.length > 0 ? mediaItems : fallbackMediaItems;

  const handleItemClick = (item) => {
    // Open modal for both images and videos
    if (onImageClick) {
      onImageClick(item);
    } else {
      console.error('onImageClick function not provided to MediaContent');
    }
  };

  return (
    <div className="media-scroll-container">
      <div className="media-horizontal-scroll">
        {items.map((item, index) => (
          <motion.div
            key={item.id}
            className="media-scroll-item"
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ delay: index * 0.05 }}
            onClick={() => handleItemClick(item)}
          >
            <div className="media-image-container">
              {item.image && (
                <img 
                  src={item.image.startsWith('http') ? item.image : process.env.PUBLIC_URL + item.image}
                  alt={item.title || 'Media'}
                  className="media-image"
                />
              )}
              {item.credit && (
                <div className="media-credit">
                  {item.credit}
                </div>
              )}
              {item.type === 'video' && (
                <div className="video-overlay">
                  <div className="video-content">
                    <div className="play-icon">▶</div>
                    <div className="video-info">
                      <div className="video-title">Official Music Video</div>
                      <div className="video-description">Nominated for best music video at Grimstad Short Film Festival 2025</div>
                    </div>
                  </div>
                </div>
              )}
              {((item.id && item.id.includes('studio')) || item.category === 'studio') && (
                <div className="studio-overlay">
                  <div className="studio-title">Studio Recording Sessions</div>
                </div>
              )}
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default MediaContent;
